import { Icon } from 'antd';
import * as React from 'react';
const SortSvg = (props) => {
  return (
    <svg {...props} viewBox="0 0 14 10">
        <g id="BL-View" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Container-Tracking-BL-FF-View-Filters"
            transform="translate(-497.000000, -155.000000)">
                <g id="Group-19" transform="translate(340.000000, 142.000000)">
                    <g id="Group-2-Copy-5" transform="translate(100.000000, 9.000000)">
                        <g id="sort" transform="translate(55.000000, 0.000000)">
                            <g id="ic_sort">
                                <polygon id="Bounds" points="0 0 18 0 18 18 0 18"></polygon>
                                {/* tslint:disable */}
                                <path d="M2.25,13.5 L6.75,13.5 L6.75,12 L2.25,12 L2.25,13.5 L2.25,13.5 Z M2.25,4.5 L2.25,6 L15.75,6 L15.75,4.5 L2.25,4.5 L2.25,4.5 Z M2.25,9.75 L11.25,9.75 L11.25,8.25 L2.25,8.25 L2.25,9.75 L2.25,9.75 Z" id="Shape" fillOpacity="0.7" fill="#000000"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  );
};

const SortIcon = props => (
  <Icon component={(innerProps) => {
    return SortSvg(Object.assign({}, innerProps, props));
  }}></Icon>
);
export default SortIcon;
